import React from "react";
import { motion } from "framer-motion";
import ConsultForm from "../ConsultForm";
import { getIcon } from "../../lib/icons";
import { Paragraph } from "./common";
import { container, item, inView } from "./presets";
import { Check, Sparkles } from "lucide-react";

export function Overview({ icon, pre, capsLabel, features, service }) {
  const Icon = getIcon(icon);
  return (
    <section className="py-16 md:py-20">
      <div className="rq-container grid lg:grid-cols-3 gap-10 lg:gap-14 items-start">
        <div className="lg:col-span-2">
          <motion.div {...inView} variants={container}>
            <motion.div variants={item} className="grid place-items-center h-16 w-16 rounded-2xl bg-[rgba(14,122,58,0.12)] text-[color:var(--rq-green)]">
              <Icon size={30} />
            </motion.div>
            {pre.map((g, gi) => (
              <div key={gi} className="mt-8">
                {g.title && (
                  <motion.h2 variants={item} className="font-display text-2xl md:text-[30px] font-bold text-white leading-snug">
                    {g.title}
                  </motion.h2>
                )}
                {g.nodes.map((n, ni) => (n.t === "p" ? (
                  <motion.div key={ni} variants={item}>
                    <Paragraph>{n.v}</Paragraph>
                  </motion.div>
                ) : null))}
              </div>
            ))}

            {features && features.length > 0 && (
              <>
                <motion.h3 variants={item} className="font-display mt-10 text-lg font-semibold text-[color:var(--rq-green)]">
                  {capsLabel}
                </motion.h3>
                <motion.div variants={container} className="mt-5 flex flex-wrap gap-2.5">
                  {features.map((f, i) => (
                    <motion.span key={i} variants={item} whileHover={{ y: -3 }} className="inline-flex items-center gap-2 rounded-full border border-[color:var(--rq-border)] bg-[var(--rq-card)] px-4 py-2 text-[13px] font-medium text-white">
                      <span className="grid place-items-center h-5 w-5 rounded-full bg-[rgba(14,122,58,0.14)] text-[color:var(--rq-green)]"><Check size={12} /></span>
                      {f}
                    </motion.span>
                  ))}
                </motion.div>
              </>
            )}
          </motion.div>
        </div>

        <div className="lg:col-span-1">
          <div className="lg:sticky lg:top-24">
            <ConsultForm source={service.title} />
          </div>
        </div>
      </div>
    </section>
  );
}

export function Closing({ group, dark }) {
  return (
    <section className={`py-16 md:py-20 ${dark ? "rq-greendark" : "rq-light"}`}>
      <div className="rq-container">
        <motion.div {...inView} variants={container} className="max-w-3xl mx-auto text-center">
          <motion.div variants={item} className="flex justify-center">
            <span className="grid place-items-center h-14 w-14 rounded-2xl bg-[rgba(14,122,58,0.12)] text-[color:var(--rq-green)]"><Sparkles size={26} /></span>
          </motion.div>
          <motion.h2 variants={item} className="font-display mt-6 text-2xl md:text-[32px] font-bold text-white leading-tight">{group.title}</motion.h2>
          {group.nodes.filter((n) => n.t === "p").map((n, i) => (
            <motion.div key={i} variants={item}>
              <Paragraph>{n.v}</Paragraph>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
